import { render, staticRenderFns } from "./NewsletterBox.vue?vue&type=template&id=d053d44c&scoped=true"
import script from "./NewsletterBox.vue?vue&type=script&lang=js"
export * from "./NewsletterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d053d44c",
  null
  
)

export default component.exports